import { controls, currencyToNumber, grouped } from "../../controls";

const gst_return_filing= {
  label: "GSTR-1  Report",
  starting: true,
  url: "gst_return_filing",
  pageLabel: "GSTR-1  Report",
  pageType: "history",
    filter: [
   ...controls.displayText({ tab: "general", label: "From Date",star:false}),
   ...controls.text({ tab: "general",length:8,placeHolder: "From Date", name: "fromdate",maxlength:50}),
   ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
   
    ...controls.displayText({ tab: "general", label: "To Date",star:false}),
    ...controls.text({ tab: "general",length:8,  placeHolder: "To Date", name: "todate",maxlength:50}),
    ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),

],

  form: [],
  history: {
    perPage: 50,
    reportHeader: "GSTR-1  Report",
    filterable: true,
    sortable: true,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    displayColumns: [
          { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
       {
        Header: "PAN",
        accessor: "pan",
      },
     
       {
        Header: "GSTIN",
        accessor: "gstin",
      },
      {
        Header: "Amount",
        accessor: "amount",
        type: "currency",
        
      },
      {
        Header: "Transaction Date",
        accessor: "transaction_date",
        type:"date"
      },
    ]
  }
};

export default gst_return_filing;